import { Store } from 'pullstate'


export const AppStore = new Store({
    apiEnvironment: null,
    checkIns: null,
    checkInGoals: null,
    departments: null,
    employees: null,
    etroTeam: false,
    goals: null,
    googleToken: null,
    loading: true,
    missingInfo: false,
    pbFilterType: null,
    pbSettings: null,
    peopleBuilders: null,
    searchText: '',
    slackUserData: null,
    slackUserTokenObject: null,
    snackbar: { message: null, type: null, open: false, openAlert: null, handleClose: null },
    steps: null,
    strengths: null,
    strengthsChecked: false,
    titles: null,
    user: null,
    workLocations: null
})

// AppStore.subscribe((state) => {
//     console.log('AppStore updated:', state)
// });